// @ts-ignore
// @ts-nocheck
import { register } from "timeago.js/lib/register";
import en from "timeago.js/lib/lang/en_US";

const supportedLanguages = ["hu", "it", "es", "pl", "el", "nl", "tr", "ro"]; // also add down for webpack
const addedLangauges = ["lt", "et", "ga", "hr"]; // also add down for webpack

register("en_US", en);

if (process.env.WEBPACK) {
    window.registerLanguageForTimeago = async function (lang) {
        if (supportedLanguages.indexOf(lang) !== -1) {
            const { default: mod } = await import(
                /* webpackInclude: /hu\.js$|it\.js$|es\.js$|pl\.js$|el\.js$|nl\.js$|tr\.js$|ro\.js$/ */
                /* webpackChunkName: "timeago-supported" */
                /* webpackMode: "lazy" */
                `timeago.js/lib/lang/${lang}`
            );
            register(lang, mod);
        } else if (addedLangauges.indexOf(lang) !== -1) {
            const { default: mod } = await import(
                /* webpackInclude: /lt\.ts$|et\.ts$|ga\.ts$|hr\.ts$/ */
                /* webpackMode: "lazy" */
                /* webpackChunkName: "timeago-added" */
                `./lang/${lang}`
            );
            register(lang, mod);
        }
    };
}
